
import breadcrumbsMixin from '@/mixins/breadcrumbs-mixin';
export default {
    mixins: [breadcrumbsMixin]
};
